<template>
  <div>
    <div>
      <b-badge
        v-for="(status, idx) in stateItems"
        :key="idx"
        :variant="getBadgeVariant(status.status)"
        class="mr-1"
        :style="
          status.status === 'resolved' && { textDecoration: 'line-through' }
        "
        v-b-tooltip="status.details"
        :title="status.details"
      >
        {{
          status.status === 'resolved'
            ? `${$t('state-resolved')}: ${status.name}`
            : status.name
        }}
      </b-badge>
      <small class="text-muted" v-if="value.contact">
        by
        <span class="text-body">
          {{ contactName }}
        </span>
        ({{ value.contact.account.role }})
      </small>
      <b-button
        v-if="value.state"
        @click="details = !details"
        size="sm"
        variant="link"
        class="gid-feed__details p-0 align-baseline ml-1 text-secondary"
      >
        <small v-if="!details">view details</small>
        <small v-else>hide details</small>
      </b-button>
    </div>
    <b-collapse v-model="details" class="mt-2">
      <small>
        <pre
          class="border rounded bg-light p-2"
          style="white-space: pre-wrap"
          >{{ value.state }}</pre
        >
      </small>
    </b-collapse>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';

export async function fetchStates({ job: { api_id: jobApiId } }) {
  const queryString = RequestQueryBuilder.create({
    filter: {
      field: `job.apiId`,
      operator: CondOperator.EQUALS,
      value: jobApiId,
    },
    sort: [{ field: 'createdAt', order: 'ASC' }],
    join: [{ field: 'job' }],
  }).query();

  const { data } = await axios.get(`/data-api/job-state/?${queryString}`);

  for (let i = data.length - 1; i >= 0; i--) {
    data[i].statuses =
      i > 0
        ? [
            ...data[i].statuses.map((status) => ({
              name: status,
              status: data[i - 1].statuses.includes(status) ? 'pending' : 'new',
            })),
            ...data[i - 1].statuses
              .filter((status) => !data[i].statuses.includes(status))
              .map((status) => ({
                name: status,
                status: 'resolved',
              })),
          ]
        : data[i].statuses.map((status) => ({
            name: status,
            status: 'new',
          }));
  }

  const stateActivities = data.map((value) => ({
    time: new Date(value.createdAt),
    value,
  }));

  return stateActivities.length === 1 && stateActivities[0].value.archived
    ? [
        ...stateActivities,
        {
          time: new Date(stateActivities[0].value.updatedAt),
          value: {
            ...stateActivities[0].value,
            statuses: stateActivities[0].value.statuses.map((status) => ({
              ...status,
              status: 'resolved',
            })),
          },
        },
      ]
    : stateActivities;
}

export function mapDetails(list, details) {
  return list.map((state) => {
    const stateName = typeof state === 'object' ? state.name : state;
    const stateWithDetails = {
      name: this.$t(`state.${stateName}`),
      status: state.status,
    };
    const stateDetails = _.get(
      details,
      stateName?.split('.').slice(0, -1).join('.'),
    );
    if (stateDetails) {
      if (stateDetails.deactivate) {
        stateWithDetails.name = this.$t(`state-until`, {
          stateName: stateWithDetails.name,
          date: this.$moment(stateDetails.deactivate.on).format('L'),
        });
      }
      if (stateDetails.details) {
        stateWithDetails.details = stateDetails.details;
      }
    }
    return stateWithDetails;
  });
}

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      details: false,
    };
  },
  methods: {
    getBadgeVariant(status) {
      switch (status) {
        case 'new':
          return 'danger';
        case 'resolved':
          return 'secondary';
        default:
          return 'warning';
      }
    },
  },
  computed: {
    stateItems() {
      return mapDetails.call(
        this,
        this.value.statuses,
        this.value.state?.context?.stateDetails,
      );
    },
    contactName() {
      const { contact } = this.value;

      return contact.firstName && contact.lastName
        ? `${contact.firstName} ${contact.lastName}`
        : contact.email;
    },
  },
};
</script>
